import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import moment from 'moment';
import { 
  DOCUMENT_LIST,
  DOCUMENT_SEARCH_DOCUMENT_TYPE,
  DOCUMENT_ADD,
  DOCUMENT_DETAIL,
  DOCUMENT_UPDATE,
  DOCUMENT_UPLOAD_SET
} from '../../actions';
import {
  DocumentListSuccess,
  DocumentListError,
  DocumentSearchDocumentTypeSuccess,
  DocumentSearchDocumentTypeError,
  DocumentAddSuccess,
  DocumentAddError,
  DocumentDetailSuccess,
  DocumentDetailError,
  DocumentUpdateSuccess,
  DocumentUpdateError,
  DocumentUploadSetSuccess,
  DocumentUploadSetError
} from '../../actions';
 
export function* watchDocumentList() {
  yield takeEvery(DOCUMENT_LIST, onDocumentList);
}

export function* watchDocumentSearchDocumentType() {
  yield takeEvery(DOCUMENT_SEARCH_DOCUMENT_TYPE, onDocumentSearchDocumentType);
}

export function* watchDocumentAdd() {
  yield takeEvery(DOCUMENT_ADD, onDocumentAdd);
}

export function* watchDocumentDetail() {
  yield takeEvery(DOCUMENT_DETAIL, onDocumentDetail);
}

export function* watchDocumentUpdate() {
  yield takeEvery(DOCUMENT_UPDATE, onDocumentUpdate);
}

export function* watchDocumentUpload() {
  yield takeEvery(DOCUMENT_UPLOAD_SET, onDocumentUpload);
}

const onDocumentListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/document/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onDocumentUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/document/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onDocumentSearchDocumentTypeAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/document_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onDocumentAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/document/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onDocumentDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/document/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onDocumentUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/document/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_documents/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_documents/'});
      });
    });
  });
};


function* onDocumentList(data) {
  try {
    const response = yield call(onDocumentListAsync, data.payload);
    yield put(DocumentListSuccess(response.data));
  } catch (error) {
    yield put(DocumentListError(error));
  }
}

function* onDocumentSearchDocumentType(data) {
  try {
    const response = yield call(onDocumentSearchDocumentTypeAsync, data.payload);
    yield put(DocumentSearchDocumentTypeSuccess(response.data));
  } catch (error) {
    yield put(DocumentSearchDocumentTypeError(error));
  }
}

function* onDocumentAdd(data) {
  try {
      const response = yield call(onDocumentAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(DocumentAddSuccess(response.data));
  } catch (error) {
      yield put(DocumentAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onDocumentDetail(data) {
  try {
    const response = yield call(onDocumentDetailAsync, data.payload);
    yield put(DocumentDetailSuccess(response.data.data));
  } catch (error) {
    yield put(DocumentDetailError(error));
  }
}

function* onDocumentUpdate(data) {
  try {
      const response = yield call(onDocumentUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(DocumentUpdateSuccess(response.data));
  } catch (error) {
      yield put(DocumentUpdateError(error));
  }
}

function* onDocumentUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onDocumentUploadAsync, file);
    if(response.message ==='success'){
      yield put(DocumentUploadSetSuccess(response));
    }
    else{
      yield put(DocumentUploadSetError(response));
    }
  } catch (error) {
    yield put(DocumentUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchDocumentList),
    fork(watchDocumentSearchDocumentType),
    fork(watchDocumentAdd),
    fork(watchDocumentDetail),
    fork(watchDocumentUpdate),
    fork(watchDocumentUpload),
  ]);
} 